export const PHONE_DISPLAY = "06 20 542 1428";
export const PHONE_TEL = "tel:+36205421428";
export const WHATSAPP = "https://wa.me/36205421428";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUSES = ["Messie/Gyűjtögetés", "Haláleset/Trauma", "Elhanyagolt ingatlan", "Egyéb"];

export const NAV = [
  { id: "garanciak", label: "Garanciák" },
  { id: "szolgaltatasok", label: "Szolgáltatások" },
  { id: "folyamat", label: "Folyamat" },
  { id: "gyik", label: "GYIK" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];
